const Errors = {
    extractErrorMessage(error) {
        if (!error.response || !error.response.data) {
            return [error];
        }

        const data = error.response.data;

        if (data.detail && Array.isArray(data.detail)) {
            let errors = [];
            for (const error of data.detail) {
                errors.push(error.msg);
            }
            return errors;
        } else if (data.detail) {
            return [data.detail];
        } 

        return [data];
    }
}
export default Errors;